import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["render"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/sort-comp */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { defaultMemoize } from 'reselect';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import _pick from 'lodash/pick';
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _isNil from 'lodash/isNil';
import _get from 'lodash/get';
import _curry from 'lodash/curry';
import _keys from 'lodash/keys';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import { Stack } from '@tekion/tmatter';
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { DEFAULT_PAGE_SIZE } from '@tekion/tekion-base/constants/tableConstants';
import { getUnWrappedPromise } from '@tekion/tekion-base/utils/promise';
import Heading from '../../atoms/Heading';
import PageComponent from '../../molecules/pageComponent/PageComponent';
import ExpandableSearch from '../ExpandableSearch';
import ExpandableSearchField from '../ExpandableSearchField';
import FilterAndSortSection from '../filterSection';
import BaseTable from '../../molecules/table/BaseTable';
import FixedColumnTable from '../../molecules/table/FixedColumnTable';
import CheckBoxTable from '../../molecules/table/CheckBoxTable';
import ActionItem from './ActionItem';
import actionTypes from './constants/actionTypes';
import tableTypes from './constants/tableTypes';

// Containers
import withRowActions from '../../molecules/table/containers/withRowActions';
import withInfiniteScroll from '../../molecules/table/containers/withInfiniteScroll';
import styles from './tableManager.module.scss';
import Button from '../../atoms/Button';
import { getSortTypeMapForColumnAction } from './TableManager.helpers';
import HeaderWithSortIndicator from '../MultiSort/components/HeaderWithSortIndicator';
var PAGE_HEADER_PROPS = ['goBackTo', 'hasBack', 'goBackHandler', 'className'];
var DEFAULT_TABLE_MANAGER_PROPS = {
  showSearch: true,
  showFilter: true,
  showMultiSort: false,
  showHeader: true,
  showSubHeader: true
};
var DEFAULT_SUB_HEADER_PROPS = {
  subHeaderLeftActions: EMPTY_ARRAY,
  subHeaderRightActions: EMPTY_ARRAY,
  className: ''
};
var DEFAULT_HEADER_PROPS = {
  label: '',
  headerLeftActions: EMPTY_ARRAY,
  headerRightActions: EMPTY_ARRAY
};
var DEFAULT_L3_HEADER_PROPS = {
  render: _noop
};
var renderHeading = function renderHeading(label) {
  return /*#__PURE__*/React.createElement(Stack, {
    align: "left"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 1
  }, label));
};
var renderActionItem = function renderActionItem(onChange, props) {
  return function (item, index) {
    var valueKey = item.valueKey;
    var valueProp = _isNil(valueKey) ? null : {
      value: _get(props, valueKey)
    };
    return /*#__PURE__*/React.createElement(ActionItem, _extends({}, item, valueProp, {
      key: index,
      handleActionItemChange: onChange
    }));
  };
};
var getTableOfType = function getTableOfType(tableType) {
  switch (tableType) {
    case tableTypes.WITH_CHECKBOX:
      return CheckBoxTable;
    case tableTypes.FIXED_COLUMN:
      return FixedColumnTable;
    default:
      return BaseTable;
  }
};
var getComponent = function getComponent(type, showActions) {
  var TableComponent = getTableOfType(type);
  var TableWithInfiniteScroll = withInfiniteScroll(TableComponent);
  if (showActions) {
    return withRowActions(TableWithInfiniteScroll);
  }
  return TableWithInfiniteScroll;
};
var getLayoutStyle = defaultMemoize(function (height, width) {
  return {
    height: height,
    width: width,
    minHeight: height
  };
});
var getMemoizedAutoSizerStyle = defaultMemoize(function (_ref) {
  var height = _ref.height,
    width = _ref.width;
  return {
    height: height,
    width: width
  };
});
var TableManager = /*#__PURE__*/function (_PureComponent) {
  _inherits(TableManager, _PureComponent);
  var _super = _createSuper(TableManager);
  function TableManager(props) {
    var _this;
    _classCallCheck(this, TableManager);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getComponent", defaultMemoize(getComponent));
    _defineProperty(_assertThisInitialized(_this), "handleTableChange", function (actionType) {
      return function (value) {
        var onAction = _this.props.onAction;
        onAction({
          type: actionType,
          payload: {
            value: value
          }
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", function (value, selectedFilterGroup, additional) {
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_ITEMS_SET_FILTER,
        payload: {
          value: value,
          selectedFilterGroup: selectedFilterGroup,
          additional: additional
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSortChange", function (sortTypeMap) {
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_ITEMS_SORT,
        payload: {
          value: {
            sortTypeMap: sortTypeMap
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleGroupConstructed", function (_ref2) {
      var groupedCount = _ref2.groupedCount;
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_ITEMS_ON_PIVOT_GROUP,
        payload: {
          groupedCount: groupedCount
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleActionItemChange", function (params) {
      var onAction = _this.props.onAction;
      onAction(params);
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionItems", function (items) {
      return _map(items, renderActionItem(_this.handleActionItemChange, _this.props));
    });
    _defineProperty(_assertThisInitialized(_this), "renderTableHeader", function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        label = _ref3.label,
        _ref3$headerLeftActio = _ref3.headerLeftActions,
        headerLeftActions = _ref3$headerLeftActio === void 0 ? [] : _ref3$headerLeftActio,
        headerRightActions = _ref3.headerRightActions,
        _ref3$rightHeaderClas = _ref3.rightHeaderClassName,
        rightHeaderClassName = _ref3$rightHeaderClas === void 0 ? '' : _ref3$rightHeaderClas;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.tableHeader, " full-width")
      }, renderHeading(label), /*#__PURE__*/React.createElement("div", {
        className: styles.customHeaderActions
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.headerLeft
      }, _this.renderActionItems(headerLeftActions)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.headerRight, " ").concat(rightHeaderClassName)
      }, _this.renderActionItems(headerRightActions))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props = _this.props,
        headerProps = _this$props.headerProps,
        history = _this$props.history,
        showHeader = _this$props.tableManagerProps.showHeader;
      if (!showHeader) return null;
      return /*#__PURE__*/React.createElement(PageComponent.Header, _extends({
        history: history
      }, _pick(headerProps, PAGE_HEADER_PROPS)), _this.renderTableHeader(headerProps));
    });
    _defineProperty(_assertThisInitialized(_this), "renderLeftSubHeaderSection", function () {
      var _this$resolvers = _this.resolvers,
        onInitialFilterResolve = _this$resolvers.onInitialFilterResolve,
        onInitialSortResolve = _this$resolvers.onInitialSortResolve;
      var _this$props2 = _this.props,
        selectedFilters = _this$props2.selectedFilters,
        selectedFilterGroup = _this$props2.selectedFilterGroup,
        filterProps = _this$props2.filterProps,
        sortDetails = _this$props2.sortDetails,
        columns = _this$props2.columns,
        isMultiSort = _this$props2.isMultiSort,
        allColumns = _this$props2.allColumns,
        subHeaderLeftActions = _this$props2.subHeaderProps.subHeaderLeftActions,
        _this$props2$tableMan = _this$props2.tableManagerProps,
        showFilter = _this$props2$tableMan.showFilter,
        showTotalCount = _this$props2$tableMan.showTotalCount,
        showMultiSort = _this$props2$tableMan.showMultiSort,
        _this$props2$tablePro = _this$props2.tableProps.totalNumberOfEntries,
        totalNumberOfEntries = _this$props2$tablePro === void 0 ? 0 : _this$props2$tablePro,
        shouldSetDefaultFilter = _this$props2.shouldSetDefaultFilter;
      var showOnlyResults = !showFilter && showTotalCount;
      var allColumnsWithFallback = !_isEmpty(allColumns) ? allColumns : columns;
      if (showFilter || showOnlyResults) {
        return /*#__PURE__*/React.createElement(FilterAndSortSection, _extends({
          onFilterApply: _this.handleFilterChange,
          onSortApply: _this.handleSortChange,
          columns: columns,
          selectedFilters: selectedFilters,
          appliedFilterGroup: selectedFilterGroup,
          totalResults: totalNumberOfEntries,
          showOnlyResults: showOnlyResults,
          sortDetails: sortDetails,
          applyInitFilter: onInitialFilterResolve,
          applyInitSort: onInitialSortResolve,
          showSortTrigger: showMultiSort && isMultiSort,
          allColumns: allColumnsWithFallback,
          shouldSetDefaultFilter: shouldSetDefaultFilter
        }, filterProps));
      }
      return _this.renderActionItems(subHeaderLeftActions);
    });
    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (value) {
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_SEARCH,
        payload: {
          value: value
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSearchField", function (value) {
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_SEARCH_FIELD,
        payload: {
          value: value
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSearchValueChange", function (value) {
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_SEARCH_TERM_UPDATE,
        payload: {
          value: value
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOnRefresh", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: actionTypes.TABLE_ITEMS_REFRESH
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderExpandableSearch", function () {
      var _this$props3 = _this.props,
        isSearchActive = _this$props3.tableManagerProps.isSearchActive,
        _this$props3$subHeade = _this$props3.subHeaderProps.expandableSearchByFieldClassName,
        expandableSearchByFieldClassName = _this$props3$subHeade === void 0 ? styles.expandableSearch : _this$props3$subHeade,
        searchText = _this$props3.searchText,
        searchPlaceholder = _this$props3.searchPlaceholder;
      return /*#__PURE__*/React.createElement(ExpandableSearch, {
        isActive: isSearchActive,
        className: expandableSearchByFieldClassName,
        onSearch: _this.handleSearch,
        value: searchText,
        placeholder: searchPlaceholder,
        onChange: _this.handleSearchValueChange
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderExpandableSearchByField", function () {
      var _this$props4 = _this.props,
        isSearchActive = _this$props4.tableManagerProps.isSearchActive,
        _this$props4$subHeade = _this$props4.subHeaderProps,
        _this$props4$subHeade2 = _this$props4$subHeade.expandableSearchClassName,
        expandableSearchClassName = _this$props4$subHeade2 === void 0 ? styles.expandableSearchByField : _this$props4$subHeade2,
        expandableSearchInputWrapperClass = _this$props4$subHeade.expandableSearchInputWrapperClass,
        expandableSearchInputClass = _this$props4$subHeade.expandableSearchInputClass,
        searchText = _this$props4.searchText,
        searchField = _this$props4.searchField,
        searchableFieldsOptions = _this$props4.searchableFieldsOptions,
        searchInputRef = _this$props4.searchInputRef,
        searchPlaceholder = _this$props4.searchPlaceholder;
      return /*#__PURE__*/React.createElement(ExpandableSearchField, {
        isActive: isSearchActive,
        className: expandableSearchClassName,
        onSearch: _this.handleSearch,
        value: searchText,
        placeholder: searchPlaceholder,
        searchField: searchField,
        onChange: _this.handleSearchValueChange,
        searchableFieldsOptions: searchableFieldsOptions,
        onChangeSearchField: _this.handleSearchField,
        inputWrapperClassName: expandableSearchInputWrapperClass,
        inputFieldClassName: expandableSearchInputClass,
        searchInputRef: searchInputRef
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderRefreshIcon", function () {
      var _this$props5 = _this.props,
        _this$props5$subHeade = _this$props5.subHeaderProps.refreshIconClassName,
        refreshIconClassName = _this$props5$subHeade === void 0 ? '' : _this$props5$subHeade,
        _this$props5$tablePro = _this$props5.tableProps.loading,
        loading = _this$props5$tablePro === void 0 ? false : _this$props5$tablePro;
      return /*#__PURE__*/React.createElement(Button, {
        view: Button.VIEW.ICON,
        className: "".concat(refreshIconClassName, " ").concat(styles.refreshIcon),
        icon: "icon-refresh",
        disabled: loading,
        onClick: _this.handleClickOnRefresh
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderRightSubHeaderSection", function () {
      var _this$props6 = _this.props,
        _this$props6$subHeade = _this$props6.subHeaderProps,
        subHeaderRightActions = _this$props6$subHeade.subHeaderRightActions,
        subHeaderCenterActions = _this$props6$subHeade.subHeaderCenterActions,
        _this$props6$tableMan = _this$props6.tableManagerProps,
        showSearch = _this$props6$tableMan.showSearch,
        showRefreshIcon = _this$props6$tableMan.showRefreshIcon,
        showSearchByField = _this$props6$tableMan.showSearchByField;
      return /*#__PURE__*/React.createElement(React.Fragment, null, _this.renderActionItems(subHeaderCenterActions), showSearch && _this.renderExpandableSearch(), showSearchByField && _this.renderExpandableSearchByField(), showRefreshIcon && _this.renderRefreshIcon(), _this.renderActionItems(subHeaderRightActions));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSubHeader", function () {
      var _this$props7 = _this.props,
        showSubHeader = _this$props7.tableManagerProps.showSubHeader,
        _this$props7$subHeade = _this$props7.subHeaderProps,
        className = _this$props7$subHeade.className,
        _this$props7$subHeade2 = _this$props7$subHeade.rightHeaderClassName,
        rightHeaderClassName = _this$props7$subHeade2 === void 0 ? styles.subHeaderRight : _this$props7$subHeade2;
      if (!showSubHeader) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.subHeaderContainer, className)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.subHeaderLeft
      }, _this.renderLeftSubHeaderSection()), /*#__PURE__*/React.createElement("div", {
        className: rightHeaderClassName
      }, _this.renderRightSubHeaderSection()));
    });
    _defineProperty(_assertThisInitialized(_this), "renderL3Header", function () {
      var _this$props8 = _this.props,
        showL3Header = _this$props8.tableManagerProps.showL3Header,
        _this$props8$l3Header = _this$props8.l3HeaderProps,
        render = _this$props8$l3Header.render,
        rest = _objectWithoutProperties(_this$props8$l3Header, _excluded);
      if (!showL3Header) return null;
      return render(_objectSpread(_objectSpread({}, _this.props), rest));
    });
    _defineProperty(_assertThisInitialized(_this), "handleRowClick", _this.handleTableChange(actionTypes.TABLE_ITEM_CLICK));
    _defineProperty(_assertThisInitialized(_this), "handlePageChange", _this.handleTableChange(actionTypes.TABLE_ITEMS_PAGE_UPDATE));
    _defineProperty(_assertThisInitialized(_this), "handleOnSelect", _this.handleTableChange(actionTypes.TABLE_ITEM_SELECT));
    _defineProperty(_assertThisInitialized(_this), "handleMultiSortUpdate", function (column) {
      return function () {
        var noOfTimesClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var _this$props9 = _this.props,
          sortDetails = _this$props9.sortDetails,
          onAction = _this$props9.onAction;
        var key = column.key;
        onAction({
          type: actionTypes.TABLE_ITEMS_SORT,
          payload: {
            value: {
              sortTypeMap: getSortTypeMapForColumnAction(key, sortDetails, noOfTimesClicked)
            }
          }
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "mapSortableColumns", function (columns, sortDetails) {
      return _map(columns, _this.addSortingToColumnHeader(sortDetails));
    });
    _defineProperty(_assertThisInitialized(_this), "getColumnsWithSortHeaders", defaultMemoize(function (isMultiSort, columns, sortDetails, showMultiSort) {
      if (!showMultiSort || !isMultiSort) return columns;
      return _this.mapSortableColumns(columns, sortDetails);
    }));
    _defineProperty(_assertThisInitialized(_this), "addSortingToColumnHeader", _curry(function (sortDetails, column) {
      var headerTitle = column.Header,
        isRightAlign = column.isRightAlign,
        key = column.key;
      if (!column.sortable) return column;
      var sortSequenceIndex = _findIndex(_keys(sortDetails), function (sortKey) {
        return sortKey === key;
      });
      return _objectSpread(_objectSpread({}, column), {}, {
        Header: /*#__PURE__*/React.createElement(HeaderWithSortIndicator, {
          headerTitle: headerTitle,
          sortSequence: sortSequenceIndex + 1,
          sortType: sortDetails[key],
          isRightAlign: isRightAlign,
          onClick: _this.handleMultiSortUpdate(column)
        }),
        sortable: false
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "renderBody", function () {
      var _this$props10 = _this.props,
        tableClassName = _this$props10.tableClassName,
        data = _this$props10.data,
        columns = _this$props10.columns,
        sortDetails = _this$props10.sortDetails,
        tableProps = _this$props10.tableProps,
        fixedPagination = _this$props10.fixedPagination,
        tableComponent = _this$props10.tableComponent,
        SubComponent = _this$props10.SubComponent,
        subRowsKey = _this$props10.subRowsKey,
        onAction = _this$props10.onAction,
        tableManagerBodyStyle = _this$props10.tableManagerBodyStyle,
        tokenPagination = _this$props10.tokenPagination,
        nextPageToken = _this$props10.nextPageToken,
        checkExpanderVisibility = _this$props10.checkExpanderVisibility,
        subComponentWrapperClassName = _this$props10.subComponentWrapperClassName,
        disableHeight = _this$props10.disableHeight,
        pageSize = _this$props10.pageSize,
        isMultiSort = _this$props10.isMultiSort,
        value = _this$props10.value,
        showMultiSort = _this$props10.tableManagerProps.showMultiSort;
      var Component = tableComponent || _this.getComponent(tableProps.type, tableProps.showActions);
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.bodyContainer, tableProps.className),
        id: "tableBody",
        style: tableManagerBodyStyle
      }, /*#__PURE__*/React.createElement(AutoSizer, {
        disableHeight: disableHeight
      }, function (layoutStyle) {
        var height = layoutStyle.height,
          width = layoutStyle.width;
        var layoutStyleForMinHeight = fixedPagination ? getLayoutStyle(height, width) : getMemoizedAutoSizerStyle(layoutStyle);
        return /*#__PURE__*/React.createElement(Component, _extends({
          style: layoutStyleForMinHeight,
          onRowClick: _this.handleRowClick,
          sortable: false,
          changePage: _this.handlePageChange,
          onSelect: _this.handleOnSelect,
          pageSize: pageSize,
          columns: _this.getColumnsWithSortHeaders(isMultiSort, columns, sortDetails, showMultiSort),
          data: data,
          SubComponent: SubComponent,
          subRowsKey: subRowsKey
        }, tableProps, {
          className: tableClassName,
          onAction: onAction,
          value: value,
          handleGroupConstructed: _this.handleGroupConstructed,
          tokenPagination: tokenPagination,
          nextPageToken: nextPageToken,
          checkExpanderVisibility: checkExpanderVisibility,
          subComponentWrapperClassName: subComponentWrapperClassName
        }));
      }));
    });
    var _onAction = _this.props.onAction;
    var _getUnWrappedPromise = getUnWrappedPromise(),
      filterDetailsFetchPromise = _getUnWrappedPromise.promise,
      _onInitialFilterResolve = _getUnWrappedPromise.resolve;
    var _getUnWrappedPromise2 = getUnWrappedPromise(),
      sortDetailsFetchPromise = _getUnWrappedPromise2.promise,
      _onInitialSortResolve = _getUnWrappedPromise2.resolve;
    Promise.all([sortDetailsFetchPromise, filterDetailsFetchPromise]).then(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        sortDetails = _ref5[0],
        filterDetails = _ref5[1];
      _onAction({
        type: actionTypes.TABLE_ITEMS_FETCH_WITH_FILTER_AND_SORT_PREFERENCES,
        payload: {
          value: {
            rows: DEFAULT_PAGE_SIZE,
            sortDetails: sortDetails,
            filterDetails: filterDetails
          }
        }
      });
    });
    _this.resolvers = {
      onInitialFilterResolve: _onInitialFilterResolve,
      onInitialSortResolve: _onInitialSortResolve
    };
    return _this;
  }
  _createClass(TableManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props11 = this.props,
        onAction = _this$props11.onAction,
        _this$props11$tableMa = _this$props11.tableManagerProps,
        showFilter = _this$props11$tableMa.showFilter,
        showTotalCount = _this$props11$tableMa.showTotalCount,
        showMultiSort = _this$props11$tableMa.showMultiSort;
      var _this$resolvers2 = this.resolvers,
        onInitialFilterResolve = _this$resolvers2.onInitialFilterResolve,
        onInitialSortResolve = _this$resolvers2.onInitialSortResolve;
      var showOnlyResults = !showFilter && showTotalCount;
      if (!showFilter && !showOnlyResults) {
        onInitialFilterResolve({});
      }
      if (!showMultiSort) {
        onInitialSortResolve({});
      }
      onAction({
        type: actionTypes.TABLE_ITEMS_FETCH,
        payload: {
          value: {
            rows: DEFAULT_PAGE_SIZE
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
        containerClassName = _this$props12.containerClassName,
        showL3HeaderAboveSubheader = _this$props12.showL3HeaderAboveSubheader;
      return /*#__PURE__*/React.createElement("div", {
        className: "full-width full-height ".concat(styles.container, " ").concat(containerClassName)
      }, this.renderHeader(), showL3HeaderAboveSubheader && this.renderL3Header(), this.renderSubHeader(), !showL3HeaderAboveSubheader && this.renderL3Header(), this.renderBody());
    }
  }]);
  return TableManager;
}(PureComponent);
_defineProperty(TableManager, "propTypes", {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string
    })
  }).isRequired,
  pageSize: PropTypes.number,
  tableManagerProps: PropTypes.shape({
    isSearchActive: PropTypes.bool,
    showFilter: PropTypes.bool,
    showSearch: PropTypes.bool,
    showHeader: PropTypes.bool,
    showSubHeader: PropTypes.bool,
    showMultiSort: PropTypes.bool
  }),
  subHeaderProps: PropTypes.shape({
    subHeaderLeftActions: PropTypes.array,
    subHeaderRightActions: PropTypes.array,
    className: PropTypes.string
  }),
  headerProps: PropTypes.shape({
    label: PropTypes.string,
    headerLeftActions: PropTypes.array,
    headerRightActions: PropTypes.array
  }),
  l3HeaderProps: PropTypes.shape({
    render: PropTypes.func
  }),
  filterProps: PropTypes.shape({
    filterTypes: PropTypes.array,
    defaultFilterTypes: PropTypes.array
  }),
  selectedFilters: PropTypes.array,
  selectedFilterGroup: PropTypes.string,
  searchText: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  tableComponent: PropTypes.element,
  fixedPagination: PropTypes.bool,
  tableProps: PropTypes.object,
  disableHeight: PropTypes.bool,
  searchableFieldsOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  onChangeSearchField: PropTypes.func,
  searchField: PropTypes.string,
  showL3HeaderAboveSubheader: PropTypes.bool,
  sortDetails: PropTypes.object,
  columns: PropTypes.array,
  searchInputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  shouldSetDefaultFilter: PropTypes.bool
});
_defineProperty(TableManager, "defaultProps", {
  pageSize: DEFAULT_PAGE_SIZE,
  tableManagerProps: DEFAULT_TABLE_MANAGER_PROPS,
  subHeaderProps: DEFAULT_SUB_HEADER_PROPS,
  headerProps: DEFAULT_HEADER_PROPS,
  l3HeaderProps: DEFAULT_L3_HEADER_PROPS,
  selectedFilters: EMPTY_ARRAY,
  selectedFilterGroup: undefined,
  searchText: '',
  searchPlaceholder: __('Search...'),
  filterProps: EMPTY_OBJECT,
  fixedPagination: true,
  tableComponent: undefined,
  tableProps: EMPTY_OBJECT,
  disableHeight: false,
  searchableFieldsOptions: EMPTY_ARRAY,
  onChangeSearchField: _noop,
  searchField: '',
  showL3HeaderAboveSubheader: false,
  sortDetails: EMPTY_OBJECT,
  columns: EMPTY_ARRAY,
  searchInputRef: null,
  shouldSetDefaultFilter: false
});
export default TableManager;